// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Container Style */
.Register_registerContainer__Ny48-,
.Register_loginContainer__l\\+p2K {
  display: flex;
  height: 100vh;
  width: 100%;
}

.Register_logo__L6J0Y {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 30px;
}

.Register_formBg__nG8FK {
  flex-grow: 1;
  position: relative;
}

.Register_background__Qw2aV {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
}

/* Form Styles */
.Register_registerForm__rBbpq,
.Register_checkEmail__9H7bW {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.Register_registerContainer__Ny48- .Register_inputs__En6Rc {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 400px;
}

.Register_registerForm__rBbpq h2 {
  font-size: 55px;
  font-weight: 600;
  line-height: 71.5px;
  color: white;
}

.Register_input__GcvBj {
  padding: 8px 16px;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  gap: 8px;
  border: 1px solid #ededed;
  color: #ededed;
  background-color: transparent;
  align-items: start;
}

.Register_input__GcvBj input {
  color: #ededed;
  background-color: transparent;
  border: none;
}

/* Button Styles */
.Register_registerBtn__8ZPnz,
.Register_resetPassBtn__14q3Z {
  width: 400px;
  height: 60px;
  border-radius: 8px;
  padding: 0 16px;
  line-height: 24px;
  color: #676c7e;
  border: none;
  cursor: pointer;
  background-color: white;
}

.Register_registerBtn__8ZPnz:disabled {
  background-color: rgb(219, 218, 218);
}

.Register_checkEmail__9H7bW p {
  line-height: 24px;
  font-size: 16px;
  font-weight: 400;
  color: white;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/register/Register.module.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;;EAEE,aAAa;EACb,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA,gBAAgB;AAChB;;EAEE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;AACd;;AAEA,kBAAkB;AAClB;;EAEE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":["/* General Container Style */\n.registerContainer,\n.loginContainer {\n  display: flex;\n  height: 100vh;\n  width: 100%;\n}\n\n.logo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0 30px;\n}\n\n.formBg {\n  flex-grow: 1;\n  position: relative;\n}\n\n.background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-top-right-radius: 50px;\n  border-bottom-right-radius: 50px;\n}\n\n/* Form Styles */\n.registerForm,\n.checkEmail {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n\n.registerContainer .inputs {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 400px;\n}\n\n.registerForm h2 {\n  font-size: 55px;\n  font-weight: 600;\n  line-height: 71.5px;\n  color: white;\n}\n\n.input {\n  padding: 8px 16px;\n  display: flex;\n  flex-direction: column;\n  border-radius: 12px;\n  gap: 8px;\n  border: 1px solid #ededed;\n  color: #ededed;\n  background-color: transparent;\n  align-items: start;\n}\n\n.input input {\n  color: #ededed;\n  background-color: transparent;\n  border: none;\n}\n\n/* Button Styles */\n.registerBtn,\n.resetPassBtn {\n  width: 400px;\n  height: 60px;\n  border-radius: 8px;\n  padding: 0 16px;\n  line-height: 24px;\n  color: #676c7e;\n  border: none;\n  cursor: pointer;\n  background-color: white;\n}\n\n.registerBtn:disabled {\n  background-color: rgb(219, 218, 218);\n}\n\n.checkEmail p {\n  line-height: 24px;\n  font-size: 16px;\n  font-weight: 400;\n  color: white;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"registerContainer": `Register_registerContainer__Ny48-`,
	"loginContainer": `Register_loginContainer__l+p2K`,
	"logo": `Register_logo__L6J0Y`,
	"formBg": `Register_formBg__nG8FK`,
	"background": `Register_background__Qw2aV`,
	"registerForm": `Register_registerForm__rBbpq`,
	"checkEmail": `Register_checkEmail__9H7bW`,
	"inputs": `Register_inputs__En6Rc`,
	"input": `Register_input__GcvBj`,
	"registerBtn": `Register_registerBtn__8ZPnz`,
	"resetPassBtn": `Register_resetPassBtn__14q3Z`
};
export default ___CSS_LOADER_EXPORT___;
